import { Component, ElementRef } from '@angular/core';

@Component({
  selector: 'uex-loading',
  templateUrl: './loading.component.html',
  host: {
    class: 'uex-loading'
  }
})
export class LoadingComponent {
  constructor(
    public elementRef: ElementRef
  ) { }

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }
}
